import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=d1fbd85e&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=d1fbd85e&prod&lang=css&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=d1fbd85e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fbd85e",
  null
  
)

export default component.exports